import Route from "@/scripts/routeRegistrar"
const RouteRegistrar = new Route('designer');


RouteRegistrar.add("designer/panel/Orders", "orders", "designerorders", "سفارشات")
RouteRegistrar.add("designer/panel/Deposits", "deposits", "designerdeposits", "پرداختی ها")

const routes = RouteRegistrar.allRoutes()


export default routes;
